var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{attrs:{"type":"MyPost","title":"我发布的数据需求"}})
}
var staticRenderFns = []

export { render, staticRenderFns }